export function initScrollProgress() {
  const progressWrap = document.querySelector('.scroll-progress');
  const progressBar = progressWrap?.querySelector('.scroll-progress__bar');

  if (!progressWrap || !progressBar) return;

  window.lenis.on('scroll', ({ progress }) => {

    if (progressBar) {
        progressBar.style.transform = `scaleX(${progress})`;
    }

    if (progressWrap) {
        if (progress < 0.01) {
            progressWrap.style.opacity = 0;
        } else {
            progressWrap.style.opacity = 1;
        }
    }
  });
}
